<p class="link-text" [innerHtml]="convertNewLinesToBr(cmt | tagUser | linkify)"></p>
